import { getHtmlStyle } from '../transfer';

const divider = {
  render(node, children) {
    const { props } = node;
    const { style } = props;

    const computeStyle = Object.assign({}, style);

    return `<div class="msg-xml-divider" style="${getHtmlStyle(computeStyle)}">${children}</div>`;
  },
};

export default divider;
